import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const chevronUpIcon: SvgIconData = {
  viewBox: '6 8 12 7.5',
  element: <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />,
};
